import '../styles/Footer.css';
import React from 'react';

const facts = [
  { label: 'Product', value: 'leads-linkedin' },
  { label: 'Purpose', value: 'LinkedIn lead extraction' },
];

function Footer() {
  return (
    <footer className="ldf-root" role="contentinfo">
      <div className="ldf-inner">
        <div className="ldf-identity">
          <p className="ldf-label">Product identity</p>
          <p className="ldf-name">leads-linkedin</p>
          <p className="ldf-context">
            Extracts leads from LinkedIn into reviewable lead lists that stay with the researcher across sessions.
          </p>
        </div>
        <dl className="ldf-meta">
          {facts.map((fact) => (
            <div className="ldf-meta-row" key={fact.label}>
              <dt className="ldf-meta-label">{fact.label}</dt>
              <dd className="ldf-meta-value">{fact.value}</dd>
            </div>
          ))}
        </dl>
      </div>
    </footer>
  );
}

export default Footer;